const ROLE_LABELS = {
  land: 'Tierra',
  ramp: 'Rampa',
  draw: 'Robo',
  removal: 'Remoción',
  synergy: 'Sinergia',
};

const ROLE_COLORS = {
  land: 'bg-yellow-700',
  ramp: 'bg-green-700',
  draw: 'bg-blue-700',
  removal: 'bg-red-700',
  synergy: 'bg-purple-700',
};

const cardRoles = { ROLE_LABELS, ROLE_COLORS };

export default cardRoles;
